

import { Component, Injector, OnInit } from '@angular/core';
import { ScheduleJobService } from 'tnx-admin-service/schedulejob/services';
import { TriggerConstants, TriggerMethodType, TriggerType } from 'tnx-admin-service/scheduletrigger/constants';
import { ScheduleTriggerService } from 'tnx-admin-service/scheduletrigger/services';
import {
    ComponentContextService, CustomControlSchema, DataFormBase, DateTimeControlSchema, DropdownControlSchema, EventData, FormSchemaBase, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'scheduletrigger-form',
    templateUrl: './scheduletrigger-form.component.html',
    styleUrls: ['./scheduletrigger-form.component.scss'],
    providers: [ComponentContextService],
})
export class ScheduleTriggerFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _scheduleTriggerService: ScheduleTriggerService,
        private _scheduleJobService: ScheduleJobService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._scheduleTriggerService;
        if (this._isFormAddNew()) {
            this.model.data.status = TriggerMethodType.Start;
            this.model.data.type = TriggerType.Simple;
        }
        this.setting.schema = <FormSchemaBase[]>[
            new DropdownControlSchema({
                label: 'Trạng thái',
                fullLabel: 'Trạng thái',
                field: 'status',
                displayField: 'label',
                valueField: 'value',
                defaultValue: TriggerMethodType.Stop,
                required: true,
                dataSource: TriggerConstants.TriggerMethodTypeDataSource,
                disabled: false,
                mdWidth: 12
            }),
            new DropdownControlSchema({
                field: 'idJob',
                label: 'Công việc',
                baseService: this._scheduleJobService,
                required: true,
                filter: true,
                valueField: 'id',
                displayField: 'name',
                mdWidth: 12
            }),
            new TextControlSchema({
                label: 'Tên lịch trình',
                fullLabel: 'Tên lịch trình - Trigger',
                field: 'name',
                mdWidth: 12,
                required: true
            }),
            new DateTimeControlSchema({
                label: 'Ngày bắt đầu',
                fullLabel: 'Ngày bắt đầu',
                field: 'startDate',
                showTime: true,
                mdWidth: 6
            }),
            new DateTimeControlSchema({
                label: 'Ngày kết thúc',
                fullLabel: 'Ngày kết thúc',
                field: 'endDate',
                showTime: true,
                mdWidth: 6
            }),
            new DropdownControlSchema({
                label: 'Kiểu lịch trình',
                fullLabel: 'Kiểu lịch trình - 0: SimpleTrigger, 1: CronTrigger',
                field: 'type',
                defaultValue: TriggerType.Simple,
                displayField: 'label',
                valueField: 'value',
                mdWidth: 6,
                required: true,
                dataSource: TriggerConstants.TriggerTypeDataSource,
            }),
            new TextControlSchema({
                label: 'Số lần chạy',
                fullLabel: 'Số lần chạy',
                field: 'intervalCount',
                dataFormat: 'number',
                min: 0
            }),
            new TextControlSchema({
                label: 'Chuỗi Cron Trigger',
                fullLabel: 'Chuỗi Cron Trigger',
                field: 'cronText',
                mdWidth: 6,
                hiddenCheck: () => {
                    return !this.model.data.type;
                }
            }),
            new CustomControlSchema({
                field: 'crudCronTextOnline',
                hiddenCheck: () => {
                    return !this.model.data.type;
                },
                mdWidth: 6
            }),
            new TextControlSchema({
                label: 'Lặp theo giờ',
                fullLabel: 'Lặp theo giờ',
                field: 'intervalHour',
                dataFormat: 'number',
                mdWidth: 4,
                hiddenCheck: () => {
                    return this.model.data.type;
                }
            }),
            new TextControlSchema({
                label: 'Lặp theo phút',
                fullLabel: 'Lặp theo phút',
                field: 'intervalMinute',
                dataFormat: 'number',
                mdWidth: 4,
                hiddenCheck: () => {
                    return this.model.data.type;
                }
            }),
            new TextControlSchema({
                label: 'Lặp theo giây',
                fullLabel: 'Lặp theo giây',
                field: 'intervalSecond',
                dataFormat: 'number',
                mdWidth: 4,
                hiddenCheck: () => {
                    return this.model.data.type;
                }
            }),
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail

    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    onBeforeSave() {
        // trước khi lưu
        this.changeStartDateEndDate();
    }

    //#region Change start date && end date

    changeStartDateEndDate() {
        if (this.model.data.startDate && this.model.data.endDate && this.model.data.startDate > this.model.data.endDate) {
            const temp = this.model.data.startDate;
            this.model.data.startDate = this.model.data.endDate;
            this.model.data.endDate = temp;
        }
    }

    //#endregion Change start date && end date
}
